import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '../modal/Modal.component';
import { WrappedButtonType } from '../ui/button';

export const ChatbotDisabledModal = ({ modalId }) => (
	<Modal
		modalId={modalId}
		className="chatbot-disabled-modal"
		header="Chat Support Unavailable"
		primaryButton={{ type: WrappedButtonType.Primary, text: 'Close' }}
		size="small"
	>
		<div className="chatbot-disabled-modal-body">
			<p>
				Chat is temporarily unavailable. Here are some resources for help with
				Stamps.com:
			</p>
			<ul>
				<li>
					The{' '}
					<a
						href="https://help.stamps.com/hc/en-us"
						target="_blank"
						rel="noopener noreferrer"
					>
						Stamps.com help center
					</a>{' '}
					has articles and resources for everything you need to do in Stamps.com
				</li>
				<li>
					Our support team can be reached by emailing{' '}
					<a href="mailto:support@stamps.com">support@stamps.com</a>
				</li>
			</ul>
		</div>
	</Modal>
);

ChatbotDisabledModal.propTypes = {
	modalId: PropTypes.number.isRequired,
};
